import { useTranslation } from "@bitsentry-ce/i18n";

export function AppErrorFallback() {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "0.5rem",
        padding: "1rem",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "1.5rem", fontWeight: 600 }}>
        {t("errors.fallback.somethingWentWrong")}
      </h1>
      <p>{t("errors.fallback.teamNotified")}</p>
    </div>
  );
}
